import React from 'react';
import classNames from 'classnames';
import { formatPriceWithComma } from 'utils/helpers';
import { useUser } from 'context/userContext';
import { SLH_TYPES } from 'api/constants';
import { IconChild, IconDoer, IconEye, IconNoRelation, IconPen, IconSoberLiving } from 'components';
import { Link } from 'react-router-dom';
import { COLORS } from 'utils/colors';

export const AssociationForSoberLiving = () => {
  const { userDetails } = useUser();
  
  return (
    userDetails &&
    userDetails?.partner_details && (
      <div className="flex flex-col gap-[18px] base-block pt-[30px] w-[450px]">
        <div className="flex justify-between items-center px-[30px] pb-[11px]">
          <div className="flex items-center gap-x-3">
            {userDetails?.partner_details?.type === SLH_TYPES.parent ? (
              <IconSoberLiving className="w-6 h-6" />
            ) : userDetails?.partner_details?.type === SLH_TYPES.child ? (
              <IconChild className="w-6 h-6" />
            ) : (
              <IconNoRelation className="w-6 h-6" />
            )}
            <p className="nunito-title">{userDetails?.partner_details?.name}</p>
          </div>
          <div className="flex justify-between items-center gap-x-3">
            <Link
              to={`/partner/view/${userDetails?.partner_details.id}`}
              className="w-8 h-8 bg-light p-1 rounded-lg"
            >
              <IconEye color={COLORS.blue} />
            </Link>
            <Link
              to={`/partner/${userDetails?.partner_details.id}`}
              className="w-8 h-8 bg-light p-1 rounded-lg"
            >
              <IconPen color={COLORS.blue} />
            </Link>
          </div>
        </div>
        <div
          className={classNames(
            'relative w-full flex flex-col pt-6 pb-[30px] gap-y-[18px] border-t border-color-lightBlue px-[30px] self-center items-center',
            'before:content-[""] before:absolute before:w-4 before:h-4 before:rounded-full before:border before:border-color-lightBlue before:bg-white before:z-10 before:top-0 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2',
          )}
        >
          {userDetails?.partner_details?.doer && (
            <span className="absolute right-0 top-0 -translate-y-1/2 px-1 py-2.5 text-14 font-medium border border-divider bg-light rounded-l-[20px]">
              <IconDoer />
            </span>
          )}
          <div className="flex flex-col gap-y-3 w-full">
            <div className="flex  justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Weekly Rate</p>
              <span className="flex-1  border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                ${formatPriceWithComma(userDetails?.partner_details?.weekly_rate)}
              </p>
            </div>
            {userDetails?.partner_details?.type === SLH_TYPES.child && (
              <div className="flex justify-between">
                <p className="text-14 text-lightBlue whitespace-nowrap">Parent</p>
                <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
                <p className="text-14 line-clamp-1 max-w-[unset]">
                  {userDetails?.partner_details?.parent.name}
                </p>
              </div>
            )}
            {userDetails?.partner_details?.type === SLH_TYPES.parent && (
              <div className="flex justify-between">
                <p className="text-14 text-lightBlue whitespace-nowrap">Children</p>
                <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
                <p className="text-14 line-clamp-1 max-w-[unset]">
                  {userDetails?.partner_details.children.length ?? 0}
                </p>
              </div>
            )}
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Gender</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.gender}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Region</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.region}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Address</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.address}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Website</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.website}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Manager</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.manager[0]?.firstname}{' '}
                {userDetails?.partner_details?.manager[0]?.lastname}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Manager Phone</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.manager[0]?.phone}
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-14 text-lightBlue whitespace-nowrap">Manager Email</p>
              <span className="flex-1 border-b border-dashed border-color-divider min-w-3" />
              <p className="text-14 line-clamp-1 max-w-[unset]">
                {userDetails?.partner_details?.manager[0]?.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  );
};
